import { styled } from '@mui/material';

export const Thumb = styled('div')`
  width: 160px;
  height: 120px;
  overflow: hidden;
  border-radius: 10px;
  cursor: pointer;
  position: relative;

  &:hover {
    .remove-btn {
      display: flex;
    }
  }
  @media (max-width: 1023px) {
    .remove-btn {
      display: flex;
    }
  }
`;

export const StyledImage = styled('img')`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const VideoW = styled('div')`
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 8px;
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
`;

export const RemoveCircle = styled('div')`
  display: none;
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: white;
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
  top: -7px;
  right: -10px;
  z-index: 100;
  justify-content: center;
  align-items: center;
`;

export const PlayButtonContainer = styled('div')`
  width: 100%;
  height: 100%;
  position: absolute;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0);
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
`;
